export default "__VITE_ASSET__itGn6sL___"